import { useQuery } from '@tanstack/react-query';
import { productsApi, NavigationData } from '@/api/customer/products';
import { productKeys } from './useProducts';

const emptyData: NavigationData = {
    categories: [],
    collections: []
};

export const useNavigationData = () => {
    const { data, isLoading, error } = useQuery({
        // We use a new query key specifically for the navigation tree
        queryKey: [...productKeys.options(), 'navigation'],
        queryFn: productsApi.fetchNavigationData,
        staleTime: 60 * 60 * 1000, // 1 hour cache since categories rarely change
        gcTime: 24 * 60 * 60 * 1000, // 24 hours
        refetchOnWindowFocus: false,
        retry: 2,
    });

    return {
        ...(data || emptyData),
        loading: isLoading,
        error: error as Error | null
    };
};
